import React, { useEffect } from 'react';
import './TutorialCongratulationsScreen.scss';
import { FormattedMessage } from 'react-intl';
import { useReward } from '../../shared/hooks/partycles-main/src/index';

interface TutorialCongratulationScreenProps {
  chapterName: string;
  congratulationsText?: string;
  onClose: () => void;
}

export function TutorialCongratulationsScreen({ chapterName, congratulationsText, onClose }: TutorialCongratulationScreenProps) {
  const { reward } = useReward('tutorial-congratulations__image', 'confetti', {
    particleCount: 69,
    spread: 60,
    startVelocity: 13,
    elementSize: 16,
    lifetime: 117,
    physics: {
      gravity: 0.55,
      wind: 0,
      friction: 0.98,
    },
    effects: {
      flutter: true,
    },
    colors: ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3'],
  });
  useEffect(() => {
    if (chapterName && congratulationsText) {
      reward();
    }
  }, [congratulationsText, chapterName]);

  if (!chapterName || !congratulationsText) {
    //last chapter has congratulations text empty. It is shown in the final screen instead
    return null;
  }

  return (
    <div className="tutorial-congratulations">
      <div className="tutorial-congratulations__close-cross" onClick={onClose}></div>
      <div className="tutorial-congratulations__image" id="tutorial-congratulations__image">
        🎉
      </div>
      <p className="tutorial-congratulations__message">
        You have completed the chapter: <strong>{chapterName}</strong>
      </p>
      <p className="tutorial-congratulations__subtitle">{congratulationsText}</p>
      <button className="tutorial-congratulations__close-btn ui button button--secondary" onClick={onClose} type="button">
        <FormattedMessage id="terms.close" />
      </button>
    </div>
  );
}
